

















import Vue from "vue";

export default Vue.extend({
  name: "snackbar",
  components: {},
  props: {
    timeout: Number,
    snackbar: Boolean,
    text: String,
    color: String
  },
  data: () => ({
    methods: {}
  })
});
